module.exports = __webpack_public_path__ + "img/adulto17.e9360720.jpg";